import multilangProps from './parts/MultilangProps';
import { is } from 'bpmn-js/lib/util/ModelUtil';

const LOW_PRIORITY = 500;

export default class MultilangprocessPropertiesProvider {

  constructor(propertiesPanel, translate) {

    this.getGroups = function (element) {
      return function (groups) {
        // Add the new group
        if (is(element, 'bpmn:Process')) {
          groups.push(createMultilangprocessGroup(element, translate));
        }
        return groups;
      };
    };

    // Use a lower priority to ensure it is loaded after the basic BPMN properties.
    propertiesPanel.registerProvider(LOW_PRIORITY, this);
  }
}

MultilangprocessPropertiesProvider.$inject = [ 'propertiesPanel', 'translate' ];

// Create the custom group called "Multilang".
function createMultilangprocessGroup(element, translate) {

  const multilangprocessGroup = {
    id: 'multilangprocess',
    label: translate('Translations'),
    entries: multilangProps(element),
    // tooltip: translate('Group tooltip')
  };

  return multilangprocessGroup;
}
